import Casier from './Casier';
import Dcp from './Dcp';
import FiletMaillant from './FiletMaillant';
import ResteSenne from './ResteSenne';
import Palangre from './Palangre';

export default class ObstacleSpawner extends Phaser.GameObjects.Container {
    constructor(scene, x, y, spawnDelay) {
        super(scene, x, y, []);

        this.scene = scene;
        this.spawnDelay = spawnDelay;
        this.obstacles = [];
        this.isSpawnerActive = true;
        this.obstacleSpeed = 0;
        scene.add.existing(this);

        this.spawner = this.scene.time.addEvent({
            delay: this.spawnDelay,
            repeat: -1,
            callback: () => {
                if (!this.isSpawnerActive) return;

                let obstacle = undefined;
                let random = Math.random();
                let lastObstacle = this.getLastObstacle();
                // console.log("Reste Scene = ", this.obstacles.find(obstacle => obstacle.type === 'resteSenne'))

                if (
                    this.obstacles.find((obstacle) => obstacle.type === 'resteSenne') !== undefined
                ) {
                    if (random > 0.5) {
                        // if (this.obstacles.find(obstacle => obstacle.type === 'palangre') === undefined) {
                        if (lastObstacle !== 'palangre') {
                            obstacle = new Palangre(
                                this.scene,
                                this.scene.width + 30,
                                this.scene.laneOne,
                                {
                                    showHitbox: false,
                                }
                            );
                        }
                    } else if (random <= 0.5) {
                        if (lastObstacle !== 'dcp') {
                            obstacle = new Dcp(
                                this.scene,
                                this.scene.width + 30,
                                this.scene.laneTwo,
                                {
                                    showHitbox: false,
                                }
                            );
                        }
                    }
                } else {
                    // } else if (this.scene.resteSenneOn === true) {
                    if (random > 0.8) {
                        // console.log("casier")
                        if (lastObstacle !== 'casier') {
                            obstacle = new Casier(
                                this.scene,
                                this.scene.width,
                                this.scene.laneFive,
                                {
                                    showHitbox: false,
                                }
                            );
                        }
                    } else if (random > 0.6) {
                        // console.log("dcp")
                        if (lastObstacle !== 'dcp') {
                            obstacle = new Dcp(this.scene, this.scene.width, this.scene.laneTwo, {
                                showHitbox: false,
                            });
                        }
                    } else if (random > 0.4) {
                        // console.log("filet")
                        if (lastObstacle !== 'filetMaillant') {
                            obstacle = new FiletMaillant(
                                this.scene,
                                this.scene.width,
                                this.scene.laneTwo,
                                {
                                    showHitbox: false,
                                }
                            );
                        }
                    } else if (random > 0.2) {
                        if (lastObstacle !== 'palangre') {
                            obstacle = new Palangre(
                                this.scene,
                                this.scene.width,
                                this.scene.laneOne,
                                {
                                    showHitbox: false,
                                }
                            );
                        }
                    } else if (random) {
                        if (lastObstacle !== 'resteSenne') {
                            this.scene.resteSenneOn = true;
                            obstacle = new ResteSenne(
                                this.scene,
                                this.scene.width,
                                this.scene.laneFive,
                                {
                                    showHitbox: false,
                                }
                            );
                        }
                    }
                }
                // console.log("obstacle", obstacle)
                if (obstacle != undefined) {
                    this.obstacles.push(obstacle);
                } else {
                    // console.log("No obstacle")
                }
            },
        });
    }

    setActive(isActive) {
        this.isSpawnerActive = isActive;
    }

    moveObstacles(delta) {
        this.obstacles.forEach((obstacle, index) => {
            obstacle.x -= (obstacle.speed + this.obstacleSpeed) * (delta / 1200); // On fait avancer l'obstacle vers le joueur
            // console.log('Obstacle type: ', obstacle.type, 'Obstacle speed: ', obstacle.speed);
            if (obstacle.x <= -obstacle.width) {
                if ((obstacle) => obstacle.type === 'resteSenne') {
                    this.scene.resteSenneOn = false;
                }
                obstacle.destroy();
                this.obstacles.splice(index, 1); // On le supprime quand il sort de l'écran
            }
        });
    }
    getLastObstacle() {
        if (this.obstacles.length > 0) {
            let lastObstacle = this.obstacles[this.obstacles.length - 1];
            return lastObstacle.type;
        }
        return null;
    }
}
